const AboutSection = () => {
  return (
    <section id="about" className="py-20 sm:py-32 bg-gradient-to-b from-white via-slate-50 to-white">
      <div className="section-container">
        <div className="max-w-4xl">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-4 tracking-tight">About Purva Swanlake</h2>
          <p className="text-xl text-slate-600 mb-12 font-light">
            Premium residential living in Kelambakkam
          </p>

          <div className="space-y-8">
            <p className="text-lg text-slate-700 leading-relaxed font-light">
              Purva Swanlake Apartment Owners Association (PSAOA) is the duly constituted and registered association representing the apartment owners of Purva Swanlake, Kelambakkam. The Association is responsible for the governance, administration, and management of common areas, shared facilities, and collective interests of its members, in accordance with its registered By-Laws and applicable law.
            </p>

            <p className="text-lg text-slate-700 leading-relaxed font-light">
              PSAOA functions under the provisions of the Tamil Nadu Societies Registration Act, 1975. This website serves as the official public information portal of PSAOA and contains verified, non-confidential information for residents, apartment owners, authorities, and service partners.
            </p>

            <div className="mt-8 bg-gradient-to-r from-blue-50 to-slate-50 border border-blue-200 rounded-lg p-6">
              <h3 className="font-bold text-lg text-foreground mb-4">Project Specifications</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                <div>
                  <p className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Total Land Area</p>
                  <p className="text-base font-bold text-foreground mt-1">10.5 Acres</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Total Units</p>
                  <p className="text-base font-bold text-foreground mt-1">729 Apartments</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Unit Types</p>
                  <p className="text-base font-bold text-foreground mt-1">2, 2.5 & 3 BHK</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Tower Configuration</p>
                  <p className="text-base font-bold text-foreground mt-1">B+S+9/10/14</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Unit Sizes</p>
                  <p className="text-base font-bold text-foreground mt-1">1272-1800 Sq.Ft.</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-blue-600 uppercase tracking-wider">RERA Status</p>
                  <p className="text-base font-bold text-foreground mt-1">Approved</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <h3 className="font-bold text-lg text-foreground mb-6">Key Information</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {/* Registration Number */}
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-6 hover:shadow-md hover:border-blue-400 transition-all duration-300 transform hover:-translate-y-1">
                  <div className="text-2xl mb-2">🏛️</div>
                  <p className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Registration</p>
                  <p className="text-lg font-bold text-blue-900 mt-1">128/2015</p>
                </div>

                {/* Date of Formation */}
                <div className="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-lg p-6 hover:shadow-md hover:border-green-400 transition-all duration-300 transform hover:-translate-y-1">
                  <div className="text-2xl mb-2">📅</div>
                  <p className="text-xs font-semibold text-green-600 uppercase tracking-wider">Formed</p>
                  <p className="text-lg font-bold text-green-900 mt-1">5 Mar 2016</p>
                </div>

                {/* No. of Flats */}
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-lg p-6 hover:shadow-md hover:border-purple-400 transition-all duration-300 transform hover:-translate-y-1">
                  <div className="text-2xl mb-2">🏠</div>
                  <p className="text-xs font-semibold text-purple-600 uppercase tracking-wider">No. of Flats</p>
                  <p className="text-lg font-bold text-purple-900 mt-1">729</p>
                </div>

                {/* Residents */}
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 rounded-lg p-6 hover:shadow-md hover:border-orange-400 transition-all duration-300 transform hover:-translate-y-1">
                  <div className="text-2xl mb-2">👥</div>
                  <p className="text-xs font-semibold text-orange-600 uppercase tracking-wider">Residents</p>
                  <p className="text-lg font-bold text-orange-900 mt-1">2000+</p>
                </div>

                {/* Location */}
                <div className="bg-gradient-to-br from-red-50 to-red-100 border border-red-200 rounded-lg p-6 hover:shadow-md hover:border-red-400 transition-all duration-300 transform hover:-translate-y-1">
                  <div className="text-2xl mb-2">📍</div>
                  <p className="text-xs font-semibold text-red-600 uppercase tracking-wider">Location</p>
                  <p className="text-lg font-bold text-red-900 mt-1">Kelambakkam</p>
                </div>

                {/* Current EC Term */}
                <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 border border-indigo-200 rounded-lg p-6 hover:shadow-md hover:border-indigo-400 transition-all duration-300 transform hover:-translate-y-1">
                  <div className="text-2xl mb-2">📋</div>
                  <p className="text-xs font-semibold text-indigo-600 uppercase tracking-wider">Current EC Term</p>
                  <p className="text-base font-bold text-indigo-900 mt-1">Nov 2025 - Oct 2026</p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
